import React from 'react';
import { Typography, Grid } from '@mui/material';
import Basico1 from '../../assets/basico1.webp';

const CourseDetails = () => {
  return (
    <>
      <Grid
        container
        spacing={3}
        sx={{
          padding: { xs: '20px', sm: '30px', md: '40px' }, // Ajuste dinámico del padding
          maxWidth: '1200px', // Establece el ancho máximo
          mx: { xs: '', sm: '20px', md: 'auto' }, // Márgenes horizontales dinámicos
        }}
      >

        <Grid item xs={12} sm={6}>
          <img
            src= {Basico1}
            alt="Programación Web"
            style={{
              width: '100%',
              borderRadius: '10px',
              boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 'bold',
              color: '#2c3e50',
              marginBottom: { xs: '10px', sm: '20px' },
              fontSize: { xs: '1.2rem', sm: '2rem' },
            }}
          >
            ¿Qué aprenderás?
          </Typography>
          <ul
            style={{
              fontSize: '0.9rem',
              color: '#7f8c8d',
              lineHeight: '1.5',
              marginBottom: '20px',
              paddingLeft: '20px',
            }}
          >
            <li>Fundamentos históricos y técnicos de la imagenología médica.</li>
            <li>Principios físicos aplicados a diversas modalidades de diagnóstico por imagen.</li>
            <li>Técnicas avanzadas de rastreo y evaluación en ultrasonido.</li>
            <li>Exploración detallada de anatomía y fisiología aplicada al diagnóstico por imágenes.</li>
            <li>Identificación y manejo de patologías ginecológicas y obstétricas.</li>
            <li>Evaluación del desarrollo y bienestar fetal a través de técnicas modernas.</li>
            <li>Diagnóstico y manejo de condiciones relacionadas con el abdomen superior y aparato genitourinario.</li>
            <li>Aplicación de técnicas Doppler para evaluar flujos y estructuras específicas.</li>
            <li>Integración de conocimientos en exámenes prácticos para reforzar habilidades.</li>
          </ul>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 'bold',
              color: '#2c3e50',
              marginBottom: { xs: '10px', sm: '20px' },
              fontSize: { xs: '1.2rem', sm: '2rem' },
            }}
          >
            Requisitos
          </Typography>
          <ul
            style={{
              fontSize: '0.9rem',
              color: '#7f8c8d',
              lineHeight: '1.5',
              marginBottom: '20px',
              paddingLeft: '20px',
            }}
          >
            <li>Licenciatura en Medicina</li>
          </ul>
        </Grid>
      </Grid>
    </>
  );
};

export default CourseDetails;
